module.exports = __webpack_public_path__ + "img/wei_he.6fee2907.png";